import { Component, Input, ViewChild } from '@angular/core';

import { ApiError, MessageService } from '../../../../core';
import { TituloReceberFilter } from '../../../titulo-receber/filter/titulo-receber-filter';
import { TituloReceberResumoFilter } from '../../../titulo-receber/resumo/filter/titulo-receber-resumo-filter';
import { TituloReceberResumoComponent } from '../../../titulo-receber/resumo/titulo-receber-resumo.component';
import { TituloReceberSituacaoPipe } from '../../../titulo-receber/situacao';
import { TituloReceber } from '../../../titulo-receber/titulo-receber';
import { ClienteLimiteCredito } from '../limite-credito';
import { ClienteLimiteCreditoHttpService } from '../limite-credito/services';
import { ClienteTituloReceberViewComponent } from './view';

@Component({
    selector: 'sgt-cliente-titulo',
    templateUrl: './cliente-titulo.component.html',
    styleUrls: [ './cliente-titulo.component.less'],
    providers: [
        TituloReceberSituacaoPipe
    ]
})
export class ClienteTituloComponent {
    dataTable: any;

    filter = new TituloReceberFilter();
    clienteLimite: ClienteLimiteCredito;
    entities: TituloReceber[];

    /** Filtro das pessoas dos títulos a receber */
    @Input() idsPessoasFilter: number[] = [];
    @Input() idRepresentante: number;
    /** Se deve exibir os limites de créditos */
    @Input() isShowLimiteCredito = true;
    // Resumo
    @ViewChild('tituloReceberResumo') tituloReceberResumo: TituloReceberResumoComponent;
    // View
    @ViewChild('tituloReceberView') tituloReceberView: ClienteTituloReceberViewComponent;

    constructor(private messageService: MessageService,
                private clienteLimiteCreditoHttpService: ClienteLimiteCreditoHttpService) { }


    /** Obtem os limítes de crédito dos clientes das pessoas informadas */
    private getClienteLimiteCredito(idsPessoas: number[]) {
        this.clienteLimiteCreditoHttpService.getLimiteCreditoByPessoa(idsPessoas)
            .subscribe(
                entity => this.clienteLimite = entity,
                (error: ApiError) => this.messageService.error(error.message, 'Erro ao obter os limites de créditos do(s) cliente(s)', error)
            );
    }

    /** Carrega o resumo dos títulos da pessoa e representante do cliente */
    private getTituloResumo(idsPessoas: number[]) {
        if (this.tituloReceberResumo) {
            const tituloReceberResumoFilter = new TituloReceberResumoFilter();
            tituloReceberResumoFilter.idsPessoas = idsPessoas;
            tituloReceberResumoFilter.idRepresentante = this.idRepresentante;

            this.tituloReceberResumo.getResumo(tituloReceberResumoFilter);
        }
    }

    /** Pesquisa os títulos das pessoas informadas */
    search(idsPessoas: number[] = []) {
        if (!idsPessoas || idsPessoas.length <= 0) {
            this.messageService.info('Selecione pelo menos um cliente', 'Informação');
            return;
        }

        // Carregando o Resumo
        this.getTituloResumo(idsPessoas);

        // Carregando os limites de crédito
        if (this.isShowLimiteCredito) {
            this.getClienteLimiteCredito(idsPessoas);
        }

        // Títulos
        this.tituloReceberView.search();
    }
}
